import icgroup from './json/icgroup.json'
import salutations from './json/salutations.json'
import contact_subjects from './json/contact_subjects.json'
import message_topics from './json/message_topics.json'
import message_subjects from './json/message_subjects.json'
import notification_types from './json/notification_types.json'
import currencies from './json/currencies.json'
import currencies_locale from './json/currencies_locale.json'
import transaction_types from './json/transaction_types.json'
import fee_statuses from './json/fee_statuses.json'
import identification_types from './json/identification_types.json'
import month_days from './json/month_days.json'
import document_types from './json/document_types.json'
import paymentServices from './json/payment_services.json'
import paymentTypes from './json/payment_types.json'
import policyTypes from './json/policy_types.json'

export default {
	window_size: {
		width: 0,
		height: 0
	},
	csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
	user: typeof localStorage.user !== 'undefined' ? JSON.parse(localStorage.user) : {},
	company: typeof localStorage.company !== 'undefined' ? JSON.parse(localStorage.company) : {},
	countries: [],
	cities: [],
	icgroup,
	salutations,
	contact_subjects,
	message_topics,
	message_subjects,
	notification_types,
	currencies,
	currencies_locale,
	transaction_types,
	fee_statuses,
	identification_types,
	month_days,
	document_types,
	paymentServices,
	paymentTypes,
	policyTypes,
}
